import { Node } from '@tiptap/pm/model'
import { Editor } from '@tiptap/react'
import React from 'react'
import NewVideoBlockView from './VideoBlockV2.js'
import VideoBlockViewV1 from './VideoBlockV1.js'

interface VideoBlockViewProps {
  editor: Editor
  getPos: () => number
  node: Node & {
    attrs: {
      src: string
      poster: string
      assetId: string
      playlistUrl?: string
    }
  }
  updateAttributes: (attrs: Record<string, string>) => void
}

export type Playlist = {
  id: string
  title: string
  description: string
  poster: string
  items: Item[]
}

export type Item = {
  src: string
  type: string
  label: string
  width: number
  height: number
}

export const VideoBlockView = (props: VideoBlockViewProps) => {
  if (props.node.attrs.playlistUrl.includes('.json')) {
    return <VideoBlockViewV1 {...props}/>
  }
  return <NewVideoBlockView {...props}/>
}

export default VideoBlockView
